import { useState } from 'react';
import { Modal, Form, Input, Button, Upload, message, Checkbox } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadCertificadosCompany } from '../../../../apis/UploadFilesCompany';
import { updateCompanyPassword } from '../../../../apis/OdooApi';

const ModalUploadFiles = ({ title, open, finish, data }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [cerFile, setCerFile] = useState(null);
  const [keyFile, setKeyFile] = useState(null);
  //const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(
    !data?.has_password
  );

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEditingPassword && values.password) {
        const passwordPayload = {
          password: values.password,
          odoo_companyId: data.id,
        };

        const passwordResponse = await updateCompanyPassword(passwordPayload);
        if (!passwordResponse.ok) {
          throw new Error(passwordResponse.message || 'Error al actualizar la contraseña');
        }
      }

      // Convertir archivos a Base64
      const cerBase64 = await fileToBase64(cerFile);
      const keyBase64 = await fileToBase64(keyFile);

      // Preparar payload para el backend
      const payload = {
        odoo_compania_id: data.id,
        cer_base64: cerBase64.split(',')[1], // Quitar el prefijo data:...
        cer_filename: cerFile.name,
        key_base64: keyBase64.split(',')[1],
        key_filename: keyFile.name,
      };

      // Llamar al servicio de API
      const response = await uploadCertificadosCompany(payload);

      if (response.ok) {
        message.success('Certificados y contraseña actualizados correctamente');
        finish(true); // Cierra el modal y refresca los datos
      } else {
        throw new Error(response.message || 'Error al subir certificados');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const beforeUpload = (file, type) => {
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (type === 'cer') {
      const isCerValid = file.type === 'application/x-x509-ca-cert' || fileExtension === 'cer';
      if (!isCerValid) {
        message.error('Debes subir un archivo CER válido');
        return Upload.LIST_IGNORE;
      }
    }

    if (type === 'key') {
      const isKeyValid = file.type === 'application/x-pem-file' ||
        fileExtension === 'key' ||
        file.type === 'application/octet-stream';
      if (!isKeyValid) {
        message.error('Debes subir un archivo KEY válido');
        return Upload.LIST_IGNORE;
      }
    }

    if (type === 'cer') setCerFile(file);
    if (type === 'key') setKeyFile(file);

    return false;
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={() => finish(false)}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>


        <Form.Item
          label="Contraseña"
          name="password"
          rules={isEditingPassword ? [{ required: true, message: 'Por favor ingresa la nueva contraseña' }] : []}
        >
          <Input.Password
            placeholder={
              isEditingPassword
                ? "Ingresa la nueva contraseña"
                : "Haz clic en 'Modificar contraseña' para editar"
            }
            disabled={!isEditingPassword}
          />
        </Form.Item>
        {data?.has_password && (
          <Form.Item>
            <Checkbox onChange={(e) => setIsEditingPassword(e.target.checked)}>
              Modificar contraseña
            </Checkbox>
          </Form.Item>
        )}

        <Form.Item
          label="Archivo .CER"
          required
        >
          <Upload
            beforeUpload={(file) => beforeUpload(file, 'cer')}
            accept=".cer,application/x-x509-ca-cert"
            maxCount={1}
            fileList={cerFile ? [cerFile] : []}
            onRemove={() => setCerFile(null)}
          >
            <Button icon={<UploadOutlined />}>Seleccionar archivo .CER</Button>
          </Upload>
        </Form.Item>

        <Form.Item
          label="Archivo .KEY"
          required
        >
          <Upload
            beforeUpload={(file) => beforeUpload(file, 'key')}
            accept=".key,application/x-pem-file"
            maxCount={1}
            fileList={keyFile ? [keyFile] : []}
            onRemove={() => setKeyFile(null)}
          >
            <Button icon={<UploadOutlined />}>Seleccionar archivo .KEY</Button>
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={!cerFile || !keyFile}
            block
          >
            Subir Archivos
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalUploadFiles;